import {
  TextField,
  Button,
} from "@mui/material";
import { useNavigate } from 'react-router-dom';
import styles from "./CreateAccount.module.css";
import PrimaryNav from "./PrimaryNav";
import GoogleLoginButton from "./GoogleLoginButton";

function CreateAccount() {
  const navigate = useNavigate();
    
  const handleButtonClick = () => {
    navigate('../accountcreatesuccess');
  };

  return (
    <div className={styles.fullWidthContainer}>
      <PrimaryNav />
      <div className={styles.container}>
        <h2 className={styles.header}>Create an account</h2>
          <p className={styles.subHeader}>
            Create or login to an account by clicking the button below.
          </p>
          <p className={styles.helperText}>
            At this time, you must use a gmail account to register. We hope to add more options soon.
          </p>
        <form className={styles.createAccount}>
          {/* <TextField
            label="Email"
            placeholder="Enter email address"
            variant="outlined"
            fullWidth
            className={styles.inputField}
          />
          <TextField
            label="Password"
            placeholder="Create a password"
            variant="outlined"
            type="password"
            fullWidth
            className={styles.inputField}
          />
          <TextField
            label="Re-enter password"
            placeholder="Re-enter your password"
            variant="outlined"
            type="password"
            fullWidth
            className={styles.inputField}
          />
          <div className={styles.primaryAction}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleButtonClick}
              className={styles.buttonPrimary}
            >
              Create
            </Button>
          </div>
          <div className={styles.separatorArea}>
            <div className={styles.or}>Or</div>
          </div> */}

          {/* Google signup */}
          <div className={styles.secondaryAction}>
            <div className={styles.specialPrimaryButtons}>
            {/* <div className={styles.googleLoginWrapper}> */}
            {/* Replace the existing Google signup button with the GoogleLoginButton */}
              <GoogleLoginButton /> {/* This will trigger Google OAuth */}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateAccount;

     





